import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudioTeachers',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};



const teachers = ref<StudioUser[]>([])
const paginationParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
})

// Computed properties
const excludedTeacherIds = computed(() => teachers.value.map((teacher) => teacher.id))

// Teachers methods
const fetchTeachers = async () => {
  if (!props.studio) return
  teachers.value = await StudioApi.fetchStudioTeachers(props.studio.id, paginationParams.value)
}

const addTeacher = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.addStudioTeacher(props.studio.id, user.id)
  if (resp) {
    teachers.value.push(user)
  }
}

const removeTeacher = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.deleteStudioTeacherById(props.studio.id, user.id)
  if (resp) {
    teachers.value = teachers.value.filter((teacher) => teacher.id !== user.id)
  }
}

onMounted(async () => {
  await fetchTeachers()
})

return { __sfc: true,props, teachers, paginationParams, excludedTeacherIds, fetchTeachers, addTeacher, removeTeacher, BKUserSelect }
}

})